export const listConstant = {
  childHeader: 'PREVENTIVE MAINTENANCE Plan list',
  addButtonLable: 'New Plan',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW PLAN',
};

export const createConstant = {
  childHeader: 'PREVENTIVE MAINTENANCE Plan list',
  theadHeader: 'PREVENTIVE MAINTENANCE Plan for the Machines for the Year',
  extracolSpan: 2,
};

export const checkListList = {
  childHeader: 'PREVENTIVE STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  deleteurl: 'preventiveMaintenancePlanRoute',
  gettableDataurl: 'preventiveMaintenancePlanRoute/monthly',
  getPlanByid: 'preventiveMaintenancePlanRoute',
  createPlanByid: 'preventiveMaintenancePlanRoute',
  updatePlanByid: 'preventiveMaintenancePlanRoute',
  sync: 'preventiveMaintenancePlanRoute/handleSync',
  getAllCheckList: 'preventiveMaintenancePlanRoute/getAllCheckList',
  checkListStatus: 'preventiveMaintenancePlanRoute/handleStatus',
  checklistUpload: 'preventiveMaintenancePlanRoute/handleUpload',
  checklistDeleteImage: 'preventiveMaintenancePlanRoute/handleDeleteImage',
  checklistData: 'preventiveMaintenancePlanRoute/checklistRoute',
};

export const tilesConstant = {
  childHeaderText: 'PREVENTIVE MAINTENANCE PLAN',
};

export const navigationConstant = {
  createPlanSchedule: '/common/preventiveMaintenancePlanCreate',
  createChecklist: '/common/preventiveMaintenancePlanChecklistCreate',
};
